import React from "react";
import { useIubendaPreferences } from "~/features/app/scripts/iubenda/hooks";
import { ConsentPlaceholder } from "./placeholder";

export function ConsentIframe(props: React.ComponentPropsWithoutRef<"iframe">) {
  const { experience } = useIubendaPreferences();

  if (!experience) {
    return <ConsentPlaceholder label={props.title || "This embedded content"} className={props.className} />;
  }

  return <iframe {...props} title={props.title || "Embedded content"} />;
}
